import { createUseStyles } from 'react-jss';

import colors from "../../utils/colors";





var styles = {
  sidebar: {
    letterSpacing: '0.02rem',
    minHeight: '100vh',
    boxSizing: 'border-box',
    maxWidth: '25rem',
    backgroundColor: colors.neutral.white,
    boxShadow: '-4px 0 4px -4px rgba(0, 0, 0, 0.16)',
    '@media (max-width: 1650px)': {
      top: '6.4rem',
      position: 'fixed',
      zIndex: 10,
      right: '0'
    }
  },

  sidebarOpened: function sidebarOpened(_ref) {var width = _ref.width;return {
      width: width || '25rem',
      opacity: '1',
      transition: 'width,opacity 400ms'
    };},

  // We have to keep this silly empty class, since react-jss support are real snails in fixing this crucial bug.
  sidebarClosed: function sidebarClosed() {return {};},
  '@media (max-width: 1650px)': {
    // MAKE IT ONLY AS FUNCTION, DUE TO React-JSS media-queries bug!!!
    sidebarClosed: function sidebarClosed() {return {
        transition: 'width,opacity 400ms',
        width: '0rem',
        opacity: '0'
      };}
  },

  // To make Sidebar big again on screen enlargement.
  '@media (min-width: 1651px)': {
    sidebarClosed: function sidebarClosed(_ref2) {var width = _ref2.width;return {
        width: width || '25rem',
        visibility: 'visible'
      };}
  },

  sidebarContent: {
    boxSizing: 'border-box',
    padding: '2rem',
    overflowX: 'hidden',
    '@media (max-width: 1651px)': {
      overflowY: 'auto',
      maxHeight: '90vh'
    }
  },
  sidebarContentVisible: {
    visibility: 'visible'
  },
  sidebarContentHidden: {
    visibility: 'hidden',
    // To make Sidebar big again on screen enlargement.
    '@media (min-width: 1651px)': {
      visibility: 'visible',
      width: '100%'
    }
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map